import styled from '@emotion/styled';
import { FormControlLabel, FormControlLabelProps, useRadioGroup } from '@mui/material';

import colors from 'styles/sass-variables.module.scss';

const StyledFormControlLabel = styled((props: FormControlLabelProps) => <FormControlLabel {...props} />)(
  ({ checked, color }) => ({
    border: `1px solid ${colors.brand_grey_light_200}`,
    padding: '16px',
    margin: '0',
    borderRadius: '4px',
    '& .MuiRadio-root': {
      padding: '0',
      marginRight: '16px',
    },
    '&.MuiFormControlLabel-root': {
      backgroundColor: checked
        ? color === 'secondary'
          ? colors.brand_orange_100
          : colors.primary_purple_100
        : 'transparent',
      borderColor: checked
        ? color === 'secondary'
          ? colors.brand_orange_300
          : colors.primary_purple_300
        : colors.brand_grey_light_200,
    },
    '& .PrivateSwitchBase-root': {
      color: checked ? (color === 'secondary' ? colors.brand_orange_default : colors.primary_purple_default) : '',
    },
    '& .MuiBox-root:first-of-type': {
      color: checked ? (color === 'secondary' ? colors.brand_orange_default : colors.primary_purple_default) : '',
    },
  }),
);

export const CustomFormControlLabel = (props: FormControlLabelProps) => {
  const radioGroup = useRadioGroup();
  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
};
